import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth, homeFor } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Marketplace from "@/pages/Marketplace";
import MyLoads from "@/pages/MyLoads";
import PostLoad from "@/pages/PostLoad";
import LoadDetail from "@/pages/LoadDetail";
import MyBids from "@/pages/MyBids";
import Connections from "@/pages/Connections";
import ConnectionDetail from "@/pages/ConnectionDetail";
import Wallet from "@/pages/Wallet";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { LangRoot } from "@/components/LanguageSwitcher";

function Protected({ roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center font-mono text-sm text-slate-500">LOADING…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return <Outlet />;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return null;
  return user ? <Navigate to={homeFor(user)} replace /> : <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <LangRoot>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected />}>
            <Route element={<AppShell />}>
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/loads/:id" element={<LoadDetail />} />
              <Route path="/connections" element={<Connections />} />
              <Route path="/connections/:id" element={<ConnectionDetail />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/profile" element={<Profile />} />
              <Route element={<Protected roles={["shipper"]} />}>
                <Route path="/my-loads" element={<MyLoads />} />
                <Route path="/post-load" element={<PostLoad />} />
              </Route>
              <Route element={<Protected roles={["transporter"]} />}>
                <Route path="/my-bids" element={<MyBids />} />
              </Route>
              <Route element={<Protected roles={["admin"]} />}>
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </LangRoot>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
